import { Button, ButtonProps } from '@mui/material'
import {
  useOtherTrayItemsContext,
  useOtherTrayItems,
} from './OtherTrayItems.context'
import { useOtherTrayItemsLogic } from './OtherTrayItems.logic'

export const OtherItemsTriggerButton = ({
  trayType,
  buttonProps = {},
}: {
  trayType: string
  buttonProps?: ButtonProps
}) => {
  const { setModalOpen, selectedItems } = useOtherTrayItemsContext()
  const { otherItems } = useOtherTrayItemsLogic(trayType)

  if (otherItems.length === 0) return null

  return (
    <Button
      onClick={() => setModalOpen(true)}
      {...buttonProps}
      variant={buttonProps.variant || 'outlined'}
    >
      Load Other Items ({selectedItems.length})
    </Button>
  )
}

export const ProcedureOtherItemsButton: React.FC<{
  onClick: () => void
  disabled?: boolean
  className?: string
  trayType: string
}> = ({ onClick, disabled = false, className, trayType }) => {
  const { otherItems } = useOtherTrayItemsLogic(trayType)
  const { selectedItems } = useOtherTrayItems(otherItems)

  if (selectedItems.length === 0) return null

  return (
    <Button
      onClick={onClick}
      className={className}
      variant="outlined"
      disabled={disabled}
      sx={{
        height: '46px',
        minWidth: '130px',
        marginRight: '8px',
        borderRadius: '4px',
        textTransform: 'none',
        fontWeight: 500,
      }}
    >
      Other Items ({selectedItems.length})
    </Button>
  )
}
